/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
var shippingTermsValue = false;
var signatureValue = false;
var listenerSet = false;
document.addEventListener("DOMContentLoaded", function(){
    var checkbox = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_1');
    var checkboxTwo = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_2');
    var checkbox_3 = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_3');
    var checkbox_4 = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_4');
    var dataId, dataIdTwo, dataId_3, dataId_4;
    
    if(typeof checkbox != "undefined" && checkbox != null || typeof checkboxTwo != "undefined" && checkboxTwo != null || typeof checkbox_3 != "undefined" && checkbox_3 != null || typeof checkbox_4 != "undefined" && checkbox_4 != null) {
        document.addEventListener('variant:added', function(event) {
           var variant = event.detail.variant; // Get the variant that was added
           
           var tempData;
           let formData = {
            'items': []
           };

           if(typeof checkbox != "undefined" && checkbox != null) {
                dataId = checkbox.dataset.productId;
                if(checkbox.checked && variant.id != dataId && dataId != '') {
                  tempData = {
                    'id': dataId,
                    'quantity': variant.quantity,
                    'properties': {
                      'For SKU': variant.sku
                    }
                  };
                  formData.items.push(tempData);
                }
            }
            
            if(typeof checkboxTwo != "undefined" && checkboxTwo != null) {
              
              dataIdTwo = checkboxTwo.dataset.productId;
              if(checkboxTwo.checked && variant.id != dataIdTwo && dataIdTwo != '') {
                tempData = {
                  'id': dataIdTwo,
                  'quantity': variant.quantity,
                  'properties': {
                    'For SKU': variant.sku
                  }
                };
                formData.items.push(tempData);
              }
            }

            if(typeof checkbox_3 != "undefined" && checkbox_3 != null) {
              dataId_3 = checkbox_3.dataset.productId;
              if(checkbox_3.checked && variant.id != dataId_3 && dataId_3 != '') {
              tempData = {
                'id': dataId_3,
                'quantity': variant.quantity,
                'properties': {
                  'For SKU': variant.sku
                }
              };
              formData.items.push(tempData);
              }
            }

            if(typeof checkbox_4 != "undefined" && checkbox_4 != null) {
              dataId_4 = checkbox_4.dataset.productId;
              if(checkbox_4.checked && variant.id != dataId_4 && dataId_4 != '') {
              tempData = {
                'id': dataId_4,
                'quantity': variant.quantity,
                'properties': {
                  'For SKU': variant.sku
                }
              };
              formData.items.push(tempData);
              }
            }
          
          if(formData.items.length > 0) {        
            
            fetch( window.themeVariables.routes.cartAddUrl + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
            
           }
    
        });
        
        document.addEventListener('cart:updated', function(event) {
            var cart = event.detail.cart; // Get the updated content of the cart
            console.log(cart);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                    cart: cart
                }
            }));
            
        });

      }

      
  //Cart checkboxes
  var minicart = document.getElementById('mini-cart');

  if(typeof minicart != 'undefined' && minicart != null) {
    console.log("mini cart exists");    
    
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        
        if (mutation.type == "childList") {
          console.log(mutation);
          if(mutation.target.classList.contains('mini-cart')) {
            init_cart_checkboxes();
          }
        } else if (mutation.type == "attributes") {
          if(mutation.target.classList.contains('mini-cart')) {
            init_cart_checkboxes();
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(minicart, config);
    
  }

  // Dropdown close if another is open
  const allFAQs = document.querySelectorAll('.product__info .faq__item button');

  if(allFAQs.length > 0) {
    const faqsArr = [];
    let activeFAQ;
    allFAQs.forEach(function(faq, index) {
      faqsArr[index] = faq;

      faqsArr[index].addEventListener('click', function() {
        if((typeof activeFAQ != 'undefined' && activeFAQ != null) && activeFAQ != this) {
          activeFAQ.click();
        } else if (activeFAQ == this) {
          activeFAQ = null;

          return;
        }

        activeFAQ = this;
      });
    });
  }
});

function init_cart_checkboxes() {
  console.log("init checkboxes");
  var shippingTerms = document.querySelector('#shipping-terms');
  var signature = document.querySelector('#signature');
  var shippingTermsLink = document.querySelector('.open-shipping-terms');
  var shippingDrawer = document.getElementById('shipping-terms-drawer');
  var signatureLink = document.querySelector('.open-signature');
  var signatureDrawer = document.getElementById('signature-drawer');
  var checkoutButton = document.querySelector('.checkout-button');
  var disclaimer = document.querySelector('.cart-disclaimer');


  if(typeof shippingTerms != 'undefined' && shippingTerms != null && typeof signature != 'undefined' && signature != null) {
    if(shippingTermsValue == true) {
      shippingTerms.checked = true;
      checkoutButton.disabled = false;
      disclaimer.style.display = 'none';
    }

    if(signatureValue == true) {
      signature.checked = true
    }

    shippingTerms.addEventListener('change', function(e){
      if (e.currentTarget.checked) {
        shippingTermsValue = true;
        checkoutButton.disabled = false;
        disclaimer.style.display = 'none';
      } else {
        shippingTermsValue = false;
        checkoutButton.disabled = true;
        disclaimer.style.display = 'block';
      }
    });

    signature.addEventListener('change', function(e){
      if (e.currentTarget.checked) {
        signatureValue = true;
        jQuery.post(window.themeVariables.routes.cartUrl+ '/update.js', "attributes[Required signature]=Yes").done(console.log('all set'));
      } else {
        signatureValue = false;
        jQuery.post(window.themeVariables.routes.cartUrl + '/update.js', "attributes[Required signature]=No").done(console.log('all set'));
      }
    });

    shippingTermsLink.addEventListener('click', function(e){
      e.preventDefault();
      
      shippingDrawer.open = true;
    });
    
    signatureLink.addEventListener('click', function(e){
      e.preventDefault();
      
      signatureDrawer.open = true;
    });
  }
}

var BrowserDetect = {
  init: function () {
      this.browser = this.searchString(this.dataBrowser) || "Other";
      this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
  },
  searchString: function (data) {
      for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          this.versionSearchString = data[i].subString;

          if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;
          }
      }
  },
  searchVersion: function (dataString) {
      var index = dataString.indexOf(this.versionSearchString);
      if (index === -1) {
          return;
      }

      var rv = dataString.indexOf("rv:");
      if (this.versionSearchString === "Trident" && rv !== -1) {
          return parseFloat(dataString.substring(rv + 3));
      } else {
          return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
      }
  },

  dataBrowser: [
      {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
      {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
      {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
      {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
      {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
      {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  

      {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
      {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
  ]
};

BrowserDetect.init();

if(BrowserDetect.browser == 'Safari') {
  document.body.classList.add('safari-browser');
}

// voltage: media gallery — desktop grid + mobile native scroll-snap swipe.
// Registered as <voltage-media-gallery> custom element (matches theme's web component pattern).
// Activates whenever the show_media_grid section setting is on (which renders the element
// into the DOM). Each grid image's alt text can carry one or more "#key_value" tags.
// The filter shows an image only if every tag matches the currently selected variant's
// value for that option (key matches the option name, normalized: lowercased, spaces → hyphens).
//
// Untagged images: always shown.
// Single-tag images: filter on one dimension.
// Multi-tag images: filter on multiple dimensions ("AND" semantics).
// Tags referring to options the product doesn't have: ignored (no constraint).
//
// Initial filter state is set in voltage-product-media-grid.liquid (no flash on load);
// this JS only handles updates on variant change.
customElements.define('voltage-media-gallery', class extends HTMLElement {

  connectedCallback() {
    var self = this;
    this._listeners = []; // track listeners for cleanup in disconnectedCallback

    var items = Array.from(this.querySelectorAll('.product__media-item'));

    // voltage: force-eager images on mobile only (horizontal swipe needs adjacent
    // images ready). Desktop keeps native lazy loading for below-fold images.
    var isMobile = window.themeVariables && window.themeVariables.breakpoints
      ? !window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches
      : window.innerWidth < 1000;
    if (isMobile) {
      items.forEach(function(item) {
        var img = item.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    }

    // --- Helpers ---

    function normalizeKey(s) {
      return (s || '').toLowerCase().trim().replace(/\s+/g, '-');
    }

    function normalizeValue(s) {
      return (s || '').toLowerCase().trim();
    }

    function parseAltTags(alt) {
      var tags = {};
      if (!alt || alt.indexOf('#') === -1) return tags;
      var segments = alt.split('#');
      for (var i = 1; i < segments.length; i++) {
        var seg = segments[i].trim();
        if (!seg) continue;
        var us = seg.indexOf('_');
        if (us === -1) continue;
        var key = normalizeKey(seg.slice(0, us));
        var val = normalizeValue(seg.slice(us + 1));
        if (key && val) tags[key] = val;
      }
      return tags;
    }

    // --- Alt-text tag parsing ---

    var itemTags = new Map();
    items.forEach(function(item) {
      var img = item.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      itemTags.set(item, parseAltTags(alt));
    });

    var optionPosByKey = {};
    (this.getAttribute('data-option-names') || '').split(',').forEach(function(name, i) {
      var key = normalizeKey(name);
      if (key) optionPosByKey[key] = i;
    });

    // --- Filter ---

    function applyFilter(variant) {
      if (!variant || !Array.isArray(variant.options)) return;
      items.forEach(function(item) {
        var tags = itemTags.get(item);
        var matches = true;
        for (var key in tags) {
          if (!Object.prototype.hasOwnProperty.call(tags, key)) continue;
          var pos = optionPosByKey[key];
          if (pos === undefined) continue;
          if (normalizeValue(variant.options[pos]) !== tags[key]) {
            matches = false;
            break;
          }
        }
        item.classList.toggle('filtered-item', matches);
      });
    }

    // Wire up to variant-picker's variant:changed event
    var variantPicker = document.querySelector('variant-picker[form-id]');
    var productForm = variantPicker ? document.forms[variantPicker.getAttribute('form-id')] : null;
    if (productForm) {
      var variantHandler = function(event) {
        applyFilter(event.detail.variant);
        requestAnimationFrame(updateProgress);
      };
      productForm.addEventListener('variant:changed', variantHandler);
      this._listeners.push({ el: productForm, evt: 'variant:changed', fn: variantHandler });
    }

    // --- Mobile swipe progress bar ---

    var progressBar = this.nextElementSibling;
    if (progressBar && !progressBar.classList.contains('gallery-progress')) progressBar = null;

    function updateProgress() {
      if (!progressBar) return;
      var max = self.scrollWidth - self.clientWidth;
      if (max <= 0) {
        progressBar.classList.add('is-empty');
        progressBar.style.setProperty('--gallery-progress', '0%');
        return;
      }
      progressBar.classList.remove('is-empty');
      var ratio = Math.max(0, Math.min(1, self.scrollLeft / max));
      progressBar.style.setProperty('--gallery-progress', (ratio * 100) + '%');
    }

    if (progressBar) {
      var scrollHandler = updateProgress;
      this.addEventListener('scroll', scrollHandler, { passive: true });
      this._listeners.push({ el: this, evt: 'scroll', fn: scrollHandler });
      updateProgress();

      var resizePending = false;
      var resizeHandler = function() {
        if (!resizePending) {
          resizePending = true;
          requestAnimationFrame(function() {
            updateProgress();
            resizePending = false;
          });
        }
      };
      window.addEventListener('resize', resizeHandler, { passive: true });
      this._listeners.push({ el: window, evt: 'resize', fn: resizeHandler });
    }

    // --- PhotoSwipe zoom ---

    var pswpElement = document.getElementById('voltage-pswp');
    var maxSpreadZoom = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.mobileZoomFactor) || 2;
    this._pswpInstance = null;

    // Preload the PhotoSwipe library so it's ready when the user taps
    if (window.LibraryLoader) {
      window.LibraryLoader.load('photoswipe');
    }

    function getFilteredImageItems() {
      return Array.from(self.querySelectorAll('.product__media-item.filtered-item[data-media-type="image"]'));
    }

    function openPhotoSwipe(clickedItem) {
      if (!pswpElement) return;
      if (!window.ThemePhotoSwipe) {
        if (window.LibraryLoader) {
          window.LibraryLoader.load('photoswipe').then(function() { openPhotoSwipe(clickedItem); });
        }
        return;
      }
      var activeItems = getFilteredImageItems();
      if (!activeItems.length) return;

      var clickedIndex = activeItems.indexOf(clickedItem);
      if (clickedIndex === -1) clickedIndex = 0;

      var pswpItems = activeItems.map(function(el) {
        var img = el.querySelector('img');
        var currentSrc = img ? (img.currentSrc || img.src) : '';
        var hiResSrc = currentSrc.replace(/(_\d+x\d+|_\d+x)?(\.(?:jpg|jpeg|png|webp|gif))/i, '_2048x$2');
        var aspectRatio = parseFloat(el.querySelector('[style*="--aspect-ratio"]')?.style.getPropertyValue('--aspect-ratio')) || 1;
        var w = Math.min(2048, window.innerWidth * window.devicePixelRatio * maxSpreadZoom);
        return {
          src: hiResSrc,
          msrc: currentSrc,
          w: Math.round(w),
          h: Math.round(w / aspectRatio)
        };
      });

      // PhotoSwipe v4 UI class
      var VoltagePhotoSwipeUI = function(pswp) {
        var uiEl = pswp.scrollWrap.querySelector('.pswp__ui');
        var handlers = [];
        function bind(selector, fn, evt) {
          evt = evt || 'click';
          var els = pswp.scrollWrap.querySelectorAll(selector);
          els.forEach(function(el) { el.addEventListener(evt, fn); handlers.push({ el: el, fn: fn, evt: evt }); });
        }
        this.init = function() {
          bind('[data-action="pswp-close"]', function() { pswp.close(); });
          bind('[data-action="pswp-prev"]', function() { pswp.prev(); });
          bind('[data-action="pswp-next"]', function() { pswp.next(); });
          var prevNext = uiEl.querySelector('.pswp__prev-next-buttons');
          var dotsWrapper = uiEl.querySelector('.pswp__dots-nav-wrapper');
          if (pswp.items.length <= 1) {
            if (prevNext) prevNext.style.display = 'none';
            if (dotsWrapper) dotsWrapper.style.display = 'none';
          } else {
            if (prevNext) prevNext.style.display = '';
            if (dotsWrapper) dotsWrapper.style.display = '';
          }
          pswp.listen('initialZoomInEnd', function() { uiEl.classList.remove('pswp__ui--hidden'); });
          pswp.listen('initialZoomOut', function() { uiEl.classList.add('pswp__ui--hidden'); });
          var tapHandler = function(e) {
            if (e.detail && e.detail.pointerType === 'mouse') {
              pswp.toggleDesktopZoom(e.detail.releasePoint);
            }
          };
          pswp.scrollWrap.addEventListener('pswpTap', tapHandler);
          handlers.push({ el: pswp.scrollWrap, fn: tapHandler, evt: 'pswpTap' });
        };
        this.destroy = function() {
          handlers.forEach(function(h) { h.el.removeEventListener(h.evt || 'click', h.fn); });
          handlers = [];
        };
      };

      self._pswpInstance = new window.ThemePhotoSwipe(pswpElement, VoltagePhotoSwipeUI, pswpItems, {
        index: clickedIndex,
        maxSpreadZoom: maxSpreadZoom,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        closeOnVerticalDrag: true,
        showHideOpacity: true,
        arrowKeys: true,
        history: false,
        getThumbBoundsFn: function(index) {
          var thumb = activeItems[index] ? activeItems[index].querySelector('img') : null;
          if (!thumb) return { x: 0, y: 0, w: 0 };
          var rect = thumb.getBoundingClientRect();
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
        getDoubleTapZoom: function(isMouseClick, item) {
          if (isMouseClick) return item.w > item.h ? 1.6 : 1;
          return item.initialZoomLevel < 0.7 ? 1 : 1.33;
        }
      });

      self._pswpInstance.listen('close', function() {
        self._pswpInstance.ui.destroy();
        self._pswpInstance = null;
      });

      self._pswpInstance.init();
    }

    // Attach click handlers to grid images
    items.forEach(function(item) {
      if (item.getAttribute('data-media-type') !== 'image') return;
      var clickHandler = function() { openPhotoSwipe(item); };
      item.addEventListener('click', clickHandler);
      self._listeners.push({ el: item, evt: 'click', fn: clickHandler });
    });
  }

  disconnectedCallback() {
    // Clean up all event listeners
    if (this._listeners) {
      this._listeners.forEach(function(l) { l.el.removeEventListener(l.evt, l.fn); });
      this._listeners = [];
    }
    // Destroy active PhotoSwipe instance
    if (this._pswpInstance) {
      this._pswpInstance.close();
      this._pswpInstance = null;
    }
  }

});

